import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/analytics"

export default class extends Controller {
  static targets = ["choice", "booking", "contact"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("rdv") === "true") {
      this.showBooking()
      setTimeout(() => {
        this.element.scrollIntoView({ behavior: "smooth", block: "center" })
      }, 100)
    }
  }

  showBooking(event = null) {
    // event est présent seulement sur un vrai clic, pas sur l'auto-ouverture ?rdv=true
    if (event) track("choix-rdv")
    this.choiceTarget.classList.add("hidden")
    this.contactTarget.classList.add("hidden")
    this.bookingTarget.classList.remove("hidden")
  }

  showContact() {
    track("choix-message")
    this.choiceTarget.classList.add("hidden")
    this.bookingTarget.classList.add("hidden")
    this.contactTarget.classList.remove("hidden")
  }

  showChoice() {
    this.bookingTarget.classList.add("hidden")
    this.contactTarget.classList.add("hidden")
    this.choiceTarget.classList.remove("hidden")
  }
}
